import './index.scss';
import React from 'react';
import { Button } from 'antd-mobile';

const Dot = (props) => (
  <div className="dot-wrapper">
    <span className="dot"></span>
    <span className="dot-label">{props.children}</span>
  </div>
);

const MultSelectGroup = (props) => {
  const { data, selected, onChange, multiple } = props;

  return Object.keys(data).map((k) => (
    <MultSelect
      id={k}
      key={k}
      onSelected={onChange}
      data={data[k]}
      selected={selected[k]}
      multiple={multiple}
    ></MultSelect>
  ));
};

const MultSelect = (props) => {
  let { id, data = {}, selected = [], onSelected = () => {}, multiple = false } = props;

  const { child, label, list } = data;

  const onCellSelected = (item) => {
    const { value } = item;
    if (value !== '') {
      if (multiple) {
        if (selected.length > 0) {
          if (selected.indexOf(value) > -1) {
            selected = selected.filter((v) => v !== value);
          } else {
            selected = [...selected, value];
          }
          onSelected({ ...item, value: [...selected] });
        } else {
          onSelected({ ...item, value: [value] });
        }
      } else {
        onSelected({ ...item, value: [value] });
      }
    } else {
      onSelected({ ...item, value: undefined });
    }
  };

  return (
    <div className="filter-tab-wrapper">
      <Dot>{label}</Dot>
      <div className="filter-button-wrapper">
        <Button
          inline
          className={`filter-button ${selected.length === 0 ? 'on' : ''}`}
          onClick={() => onCellSelected({ id, child, value: '' })}
        >
          全部
        </Button>
        {(list || []).map((item) => (
          <Button
            key={item.value}
            inline
            className={`filter-button ${selected.indexOf(item.value) > -1 ? 'on' : ''}`}
            onClick={() => onCellSelected({ id, child, value: item.value })}
          >
            {item.name}
          </Button>
        ))}
      </div>
    </div>
  );
};

export { MultSelectGroup, MultSelect };
